import {request} from "./request";


export function GetStatisInfo() {
  return request({
    url: 'admin/GetStatisInfo',
  })
}

export function GetControlInfo() {
  return request({
    url: 'admin/GetControlInfo',
  })
}

export function ChangeControlInfo(course, club,startTime) {
  return request({
    url: 'admin/ChangeControlInfo',
    params: {
      course, club,startTime
    }
  })
}
